import React, { useState } from 'react';

const Section8Company = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with Section 8 Company registration.',
    website_hp: ''
  });

 const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with 8 Company registration.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-20">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Section 8 Company Registration
            </h1>
            <p className="mt-4 text-xl text-blue-100">
              The non-profit structure for promoting commerce, art, science, and social welfare with corporate credibility.
            </p>
            <div className="mt-8">
              <a href="#contact-section" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                  <span className="mr-2">🤝</span> Start Your Non-Profit
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#details">Overview & Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Registration Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">Documents Required</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#you-get">What You Get</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#service-faqs">FAQs</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">
                Overview of Section 8 Company
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                A <strong>Section 8 Company</strong> is a non-profit organization registered under the Companies Act, 2013, for the sole purpose of promoting charitable objectives like commerce, art, science, social welfare, or religion. Unlike other companies, it uses all its profits solely for promoting its objects and is strictly <strong>prohibited from paying any dividend</strong> to its members.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                This structure combines the best of a company format (limited liability, separate legal entity, and perpetual succession) with the objective of a non-profit organization, making it highly credible for receiving donations and grants. It is the modern equivalent of the old Section 25 Company.
              </p>

              <div className="mt-8">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">
                  Key Features & Benefits
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Charitable Purpose Only:</strong> Profits can only be used to further the company's non-profit objectives.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Tax Benefits:</strong> Eligible to apply for 80G and 12A registration under the Income Tax Act for donor benefits and tax exemptions.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Limited Liability & Credibility:</strong> Offers directors limited liability and enjoys the trust associated with a corporate structure.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">No Minimum Capital:</strong> There is no legal requirement for a minimum paid-up capital contribution.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Fewer Compliance Rules:</strong> Benefits from several exemptions and reduced compliance burdens compared to Private Limited Companies.
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-100 text-red-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">❌</span>
                    There was an error submitting your form. Please try again.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with Section 8 Company registration." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Procedure Section */}
      <section id="procedure" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Our Detailed Process
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              8 Steps for Section 8 Company Registration
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-6 grid-flow-row-dense">
            {[
              { number: "01", icon: "📊", title: "KYC & Documents", desc: "Collection of KYC documents and initial payment from directors/subscribers." },
              { number: "02", icon: "🔒", title: "Procure DSC & DIN", desc: "Application for Digital Signature Certificate (DSC) and Director Identification Number (DIN)." },
              { number: "03", icon: "🏢", title: "Name Reservation", desc: "Filing for reservation of the company name with the Ministry of Corporate Affairs (MCA)." },
              { number: "04", icon: "📄", title: "License Application (INC-12)", desc: "Filing of Form INC-12, MoA/AoA drafts, and financial estimates to obtain the Section 8 License." },
              { number: "05", icon: "🏆", title: "License Issued", desc: "The Central Government or ROC approves and issues the Section 8 License (Form INC-13)." },
              { number: "06", icon: "✅", title: "Filing SPICe+ Part B", desc: "Final submission of the incorporation form along with the obtained license and final MoA/AoA." },
              { number: "07", icon: "🖋️", title: "Issuance of COI", desc: "The Registrar of Companies (ROC) issues the Certificate of Incorporation." },
              { number: "08", icon: "📬", title: "Final Document Delivery", desc: "Delivery of COI, License, MoA, AoA, PAN, TAN, and assistance with bank account opening." }
            ].map((step, index) => (
              <div key={index} className="sm:col-span-2 lg:col-span-2 p-4 bg-white rounded-xl shadow-lg text-center hover:shadow-xl transition-shadow border-t-4 border-blue-500 h-full">
                <div className="procedure-step-content">
                  <div>
                    <span className="text-2xl font-extrabold text-blue-600 block mb-2">{step.number}</span>
                    <span className="text-2xl mx-auto mb-2 block">{step.icon}</span>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">{step.title}</h3>
                  </div>
                  <p className="text-gray-600 text-sm mt-3">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Only Scanned Copies are required
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Mandatory Documents for Section 8 Company
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "🆔", title: "Directors' KYC & Photo", desc: "PAN Card, Aadhar Card/Voter ID/Passport copy, and passport size photograph of all proposed directors/subscribers." },
              { icon: "📍", title: "Directors' Address Proof", desc: "Bank Statement/Mobile Bill/Electricity Bill for all directors. (Must be less than 30 Days old)." },
              { icon: "🏢", title: "Registered Office Proof", desc: "Rent agreement/Sale Deed, NOC from the owner, and latest Utility Bill (must be less than 30 days old)." },
              { icon: "📝", title: "MoA & AoA Drafts", desc: "Draft Memorandum and Articles of Association adhering to Section 8 regulations." },
              { icon: "💰", title: "Financial Statements & Estimates", desc: "Declaration of non-profit intent and estimated statements of income and expenditure for the next three years." },
              { icon: "📋", title: "List of Promoters & Objects", desc: "A detailed list of the proposed promoters/directors and the specific charitable objectives of the company." }
            ].map((doc, index) => (
              <div key={index} className="p-6 border rounded-xl shadow-md flex items-start space-x-4 h-full">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{doc.title}</h3>
                  <p className="text-gray-600 text-sm mt-1">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section id="you-get" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Your Deliverables
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Akir Advisory Delivers
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: "📋", title: "Certificate of Incorporation", desc: "The official legal document issued by the ROC." },
              { icon: "🏆", title: "Section 8 License (INC-13)", desc: "The mandatory license issued by the Central Government permitting non-profit operation." },
              { icon: "📚", title: "Stamped MoA & AoA", desc: "The Memorandum and Articles of Association approved by the ROC." },
              { icon: "🆔", title: "Company PAN and TAN", desc: "The Permanent Account Number and Tax Deduction Account Number for the Section 8 Company." }
            ].map((item, index) => (
              <div key={index} className="p-6 bg-white rounded-xl shadow-lg border-l-4 border-green-500 h-full flex flex-col">
                <span className="text-2xl mb-3 block">{item.icon}</span>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="service-faqs" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Common Questions
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Section 8 Company FAQs
            </p>
          </div>
          
          <div className="space-y-4 max-w-4xl mx-auto">
            <div className="border rounded-lg p-5 shadow-sm">
              <h4 className="font-semibold text-lg text-gray-900 mb-2">Can a Section 8 Company distribute profits or pay dividends?</h4>
              <p className="text-gray-600">No, a Section 8 Company is <strong>strictly prohibited</strong> from paying dividends to its members. Any income or profit must be applied solely towards promoting the company's non-profit objectives.</p>
            </div>
            <div className="border rounded-lg p-5 shadow-sm">
              <h4 className="font-semibold text-lg text-gray-900 mb-2">Is there a minimum capital requirement?</h4>
              <p className="text-gray-600">No, the Companies Act, 2013, <strong>does not stipulate any minimum paid-up capital</strong> for the registration of a Section 8 Company.</p>
            </div>
            <div className="border rounded-lg p-5 shadow-sm">
              <h4 className="font-semibold text-lg text-gray-900 mb-2">How many directors are needed for registration?</h4>
              <p className="text-gray-600">A minimum of <strong>two directors</strong> and two shareholders/members (who can be the same persons) are required to register a Section 8 Company.</p>
            </div>
            <div className="border rounded-lg p-5 shadow-sm">
              <h4 className="font-semibold text-lg text-gray-900 mb-2">What happens if the company violates its non-profit nature?</h4>
              <p className="text-gray-600">The Central Government can <strong>revoke the company's license</strong>. The company may then be wound up, or required to change its name and convert to another business structure.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-blue-700/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-extrabold text-white">
            Ready to Establish Your Non-Profit Mission?
          </h2>
          <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto">
            Secure your Section 8 license and benefit from tax exemptions with expert legal guidance.
          </p>
          <a href="#contact-section" className="mt-8 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
            <span className="mr-2">📞</span> Consult Our Experts Today
          </a>
        </div>
      </section>
    </main>
  );
};

export default Section8Company;